export const categories = [
  {
    key: "gossip",
    name: "娱乐八卦",
    desc: "热点吃瓜、话题速递",
    icon: "ri-chat-3-line",
    count: 1260,
  },
  {
    key: "celeb",
    name: "明星动态",
    desc: "红毯、路透、营业日常",
    icon: "ri-star-line",
    count: 980,
  },
  {
    key: "bts",
    name: "影视花絮",
    desc: "片场趣事、拍摄幕后",
    icon: "ri-movie-2-line",
    count: 740,
  },
  {
    key: "variety",
    name: "综艺名场面",
    desc: "高能片段、出圈名场面",
    icon: "ri-tv-2-line",
    count: 1520,
  },
  {
    key: "behind",
    name: "幕后探班",
    desc: "妆造、道具、排练记录",
    icon: "ri-vidicon-line",
    count: 430,
  },
];

export const durationFilters = [
  { key: "all", label: "全部时长" },
  { key: "short", label: "短视频 · 5分钟内" },
  { key: "medium", label: "中视频 · 5-20分钟" },
  { key: "long", label: "长视频 · 20分钟以上" },
];